import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target", "rel"]
const _hoisted_2 = { class: "data-table-link-cell__text" }

import { Icon } from "@iconify/vue";

interface Props {
  href: string;
  label: string;
  external?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkCell',
  props: {
    href: {},
    label: {},
    external: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: __props.href,
    target: __props.external ? '_blank' : undefined,
    rel: __props.external ? 'noopener noreferrer' : undefined,
    class: "data-table-link-cell"
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1),
    (__props.external)
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 0,
          icon: "mdi:open-in-new",
          class: "data-table-link-cell__icon"
        }))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})